import React from 'react';

import {Box, Stack} from 'views/components';

const ThinkingDots = () => (
  <Stack direction='row' alignItems='center' sx={{gap: '4px', py: '2px'}}>
    {[0, 1, 2].map((i) => (
      <Box
        key={i}
        sx={{
          'width': '6px',
          'height': '6px',
          'borderRadius': '50%',
          'backgroundColor': '#A8A49E',
          'animation': 'pulse 1.2s ease-in-out infinite',
          'animationDelay': `${i * 0.2}s`,
          '@keyframes pulse': {
            '0%, 100%': {opacity: 0.3, transform: 'scale(0.8)'},
            '50%': {opacity: 1, transform: 'scale(1)'},
          },
        }}
      />
    ))}
  </Stack>
);

export default ThinkingDots;
